export enum DefectivePartType {

    //Grid
    GET_DEFECTIVE_PART_LIST_LOADING = "@@defective_part/GET_DEFECTIVE_PART_LIST_LOADING",
    GET_DEFECTIVE_PART_LIST_SUCCESS = "@@defective_part/GET_DEFECTIVE_PART_LIST_SUCCESS",
    GET_DEFECTIVE_PART_LIST_ERROR = "@@defective_part/GET_DEFECTIVE_PART_LIST_ERROR",

    GET_LOCATION_FOR_DEFECTIVE_PART_LOADING = "@@defective_part/GET_LOCATION_FOR_DEFECTIVE_PART_LOADING",
    GET_LOCATION_FOR_DEFECTIVE_PART_SUCCESS = "@@defective_part/GET_LOCATION_FOR_DEFECTIVE_PART_SUCCESS",
    GET_LOCATION_FOR_DEFECTIVE_PART_ERROR = "@@defective_part/GET_LOCATION_FOR_DEFECTIVE_PART_ERROR",

}